import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";
import { getMerchantBalance } from "utils/AxiosUtil";

// Merchant balance in the selected token, keyed by the merchant's on-chain address
// (resolved from useMerchantInfo). Disabled until the address is available.
export function useMerchantBalance(merchantAddress: string | undefined) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  return useQuery<number>({
    // Token in the key is load-bearing: staleTime is Infinity and refetchOnMount is false,
    // so without it a switch would serve the old token's balance and never refetch.
    queryKey: ["merchantBalance", merchantAddress, token],
    queryFn: async () => {
      const res = await getMerchantBalance(
        merchantAddress!,
        networkType,
        token,
      );
      return res.data;
    },
    enabled: !!user && !!merchantAddress,
  });
}
